<div>
    <div role="alert"
         class="alert alert-info">Orphan People are those people with no connections to ANY organisation (mistakenly added or not cleaned up
        properly)</div>

    <button class="btn btn-default"
            [adaptBlockingClick]="doCheck">Check for Orphan People</button>

    <hr />

    @if (people) {
        <div>
            <table class="table table-bordered table-striped table-hover table-responsive">
                <thead>
                    <tr>
                        <td>PersonId</td>
                        <td>Name</td>
                    </tr>
                </thead>
                <tbody>
                    @for (user of people; track user) {
                        <tr>
                            <td>{{ user.Id }}</td>
                            <td>{{ user.Value }}</td>
                        </tr>
                    }
                </tbody>
            </table>
            <hr />
            @if (people.length) {
                <div role="alert"
                     class="alert alert-warning">
                    <h3>*** Note: This operation is not recoverable. ***</h3>
                </div>
            }
            @if (people.length) {
                <button [adaptBlockingClick]="doDelete"
                        adaptButton="delete">Orphan People</button>
            }
        </div>
    }

    @if (error) {
        <div role="alert"
             class="alert alert-danger">{{ error }}</div>
    }
</div>
